import { useDispatch, useSelector } from "react-redux";
import BasicCardDocumentos from "../BasicCardDocumentos";
import InputForm from "../InputFormV2";
import { State } from "../../../../reducers";
import useNotaRemision from "../../../../actions/nota-remision.actions";
import { useEffect, useState } from "react";

import HelpIcon from '../../../../media/felsv/help-circle-svgrepo-com.svg';
import DeleteIcon from '../../../../media/felsv/dark_recyclebin_icon.svg'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import { Pagination } from "../../../../components/Pagination";
import { bindActionCreators } from "redux";
import { actionGeneral, actionsLogin } from "../../../../actions/action-creators";
import DocumentosReceptor from "../../../../components/DocumentoReceptor/DocumentosReceptor";
import { BannerElegirSucursal } from "../../../../components/Banner/BannerElegirSucursal";
import ModalDocFisicos from "../../../../components/Modals/DocumentoFisico/ModalDocFisicos";
import { DocFisico } from "../../../../interfaces/general.interface";
import InputChips from "../InputChips";
import useUtilsDocs, { esCatalogoProductoByTipo, processDetalleImpuestosHTML } from "../../../../actions/utils-documentos.actions";
import { Tooltip } from "../../../../components/Tooltip/Tooltip";
import InputSwitchDescripcion, { CheckBoxFlag } from "../InputSwitchDescripcion";
import ObservacionesDocumentoBase from "../../../../components/ObservacionesDocumento/ObservacionesDocumento";
import { NOTA_REMISION_TYPES } from "../../../../constants/nota-remision-types"
import { getMinDateRetroactiva } from "../../../../utils/stringDate";

export default function FormulariosNR (){
    const dteCode = "04";
    const {fecha_actual} = useSelector((state: State) => state.general)
    const config = useSelector((state: State) => state.userLogin.config)
    const {formCliente, errorsCliente, formProducto, errorsProducto, calculosProducto, productos, asociarDocumentos, loader_asociarDocumentos, documentosAsociados, documentosEncontrados, tableProductos, modal_documentoFisico, formObservaciones} = useSelector((state: State) => state.notaRemision)
    const {tipoDocumento, departamentos, municipios, actividadesEconomicas, tipoDocumentosEmision, datosEmisor, unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    
    const [customDescripcion, setCustomDescripcion] = useState(false);
    const [checkTextoEnrequecido, setCheckTextoEnrequecido] = useState(false);
    
    const {
        onChangeFormCliente,
        onChangeFormProducto,
        onChangeSelectCatalogoProducto,

        cargarDatosIniciales,
        buscarCliente,
        
        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,
        button_asociarDocumentos,

        validateFormCliente,
        validateFormProducto,

        actionButton_editar,
        actionButton_eliminarProducto,
        actionButton_desasociar,
        buttonActiveModalBusquedaDocumentos,
        setTableProductos,

        cargarSucursales,
        modal_OpenDocumentoFisico,
        actionButton_asociarFisico,
        modal_OpenAgregarProdFisico,

    } = useNotaRemision()
    const dispatch = useDispatch()

    const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
    const {getFechaHora, validateHorarioSucursal, validateUsoModulo} = bindActionCreators(actionGeneral, dispatch)
    
    const {processOtrosImpuestosCalculo, procesOtrosImpuestosResumen} = useUtilsDocs();

    const handleChangeFormCliente = (e: any) => {
        onChangeFormCliente(e.target.name, e.target.value)
    }
    const handleChangeFormProducto = (e: any) => {
        onChangeFormProducto(e.target.name, e.target.value)
        if (e.target.name === "descripcion" && e.target.value === "") {setCustomDescripcion(false)}
    }
    const handleBlurFormCliente = async(e: any) => {
        validateFormCliente(e.target.name, e.target.value)
        if(e.target.name === 'noDocumento') await buscarCliente()
    }
    const handleBlurFormProducto = (e: any) => {
        validateFormProducto(e.target.name, e.target.value)
    }
    const handleSelectCatalogoProducto = (e: any) => {
        if (e.label != -1) onChangeSelectCatalogoProducto(e.value);
        else {
            setCustomDescripcion(true);
            setCheckTextoEnrequecido(false);
            onChangeFormProducto('descripcion', e.value, {clave: '', tributos: []});
        }
    }
 
    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    let sumaOperaciones = 0
    let iva = 0
    let subtotal = 0
    let ivaPercibido = 0
    let ivaRetenido = 0
    let retencionRenta = 0
    let total = 0
    let otrosImpuestos = 0
    let resumenTributos:Array<any> = [];

    productos.forEach((producto) => {
        let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
        let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
        let ivaProducto = ((precioUnitario * parseFloat(producto.cantidad)) - descuento) * 0.13

        const precio = (precioUnitario * parseFloat(producto.cantidad)) - descuento;
        sumaOperaciones += precio;
        otrosImpuestos += processOtrosImpuestosCalculo(dteCode, producto, precio, false);
        resumenTributos = procesOtrosImpuestosResumen(dteCode, resumenTributos, producto, precio);

        if(!producto.exento){
            iva += ivaProducto
            subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento) + ivaProducto
        } else {
            subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
        }
    })

    resumenTributos.forEach((resum) => {
        resum.valor = parseFloat(resum.valor.toFixed(2));
    });
    
    subtotal += otrosImpuestos;
    total = subtotal;

    useEffect(() => {
        validateUsoModulo()
        validateHorarioSucursal()
        suscripcionGetFacturasDisponibles()
        cargarSucursales()
        cargarDatosIniciales()
        getFechaHora()
    }, [])

    useEffect(() => {
        setTableProductos(productos)
    }, [productos])
    
    const [tableDocumentosAsociados, setTableDocumentosAsociados] = useState<Array<any>>([])

    const existenFisicos = () => documentosAsociados.find((doc) => doc?.fisico === true)

    return(
        <>
            <BannerElegirSucursal />
            {modal_documentoFisico && <ModalDocFisicos idTipoDoc={["01", "03", "11"]} documentoEdit={null} onClicCerrar={() => {modal_OpenDocumentoFisico(false)}} onClicAgregar={(documento: DocFisico) => {actionButton_asociarFisico(documento)}} ocultarMonto={true} noCerrarAuto={true} minMes={-(12*10)} />}
            <div className="otros-documentos-container">
                <div className='dos-columnas-resp'>
                <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
                <BasicCardDocumentos title="Datos del cliente">
                    <InputForm required name = 'granContribuyente' label = 'Gran contribuyente' type = 'checkbox' value = {formCliente.granContribuyente} onChange = {(e: any) => onChangeFormCliente('granContribuyente', !formCliente.granContribuyente)}/>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm name = 'fecha' placeholder = 'Fecha de emisión' label = 'Fecha' type = 'date'
                            value = {config?.facturacion_retroactiva ? formCliente.fecha : fecha_actual?.FechaInput}
                            disabled = {!config?.facturacion_retroactiva}
                            min = {config?.facturacion_retroactiva && config?.dias_facturacion_retroactiva && fecha_actual?.FechaInput ? getMinDateRetroactiva(config.dias_facturacion_retroactiva, fecha_actual.FechaInput) : undefined}
                            max = {config?.facturacion_retroactiva ? fecha_actual?.FechaInput : undefined}
                            error = {errorsCliente.fecha}
                            onChange = {config?.facturacion_retroactiva ? (e: any) => onChangeFormCliente('fecha', e.target.value) : undefined}
                        />
                        <InputForm required options = {tipoDocumento} keyNameText = 'valor' keyNameValue = 'codigo' name = 'tipoDocumento' placeholder = 'Tipo de documento de identificación' label = 'Tipo de documento de identificación' type = 'select' value = {formCliente.tipoDocumento} error = {errorsCliente.fecha} onChange = {(e: any) => onChangeFormCliente('tipoDocumento', e.value)}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled = {!formCliente.tipoDocumento || formCliente.tipoDocumento === ''} onBlur = {handleBlurFormCliente} required name = 'noDocumento' placeholder = {tipoDocumento.find((doc: any) => doc.codigo === formCliente.tipoDocumento && doc.codigo !== '37')?.valor || 'No. Documento de identificación'} label = {tipoDocumento.find((doc: any) => doc.codigo === formCliente.tipoDocumento && doc.codigo !== '37')?.valor || 'No. Documento de identificación'} type = 'text' value = {formCliente.noDocumento} error = {errorsCliente.noDocumento} onChange = {handleChangeFormCliente}/>
                        <InputForm onBlur = {handleBlurFormCliente} required name = 'nombre' placeholder = 'Nombre' label = 'Nombre' type = 'text' value = {formCliente.nombre} error = {errorsCliente.nombre} onChange = {handleChangeFormCliente}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm required options = {departamentos} keyNameText = 'valor' keyNameValue = 'codigo' name = 'departamento' placeholder = 'Departamento' label = 'Departamento' type = 'select' value = {formCliente.departamento} error = {errorsCliente.departamento} onChange = {(e: any) => onChangeFormCliente('departamento', e.value)}/>
                        <InputForm required options = {municipios} keyNameText = 'valor' keyNameValue = 'codigo' name = 'municipio' placeholder = 'Municipio' label = 'Municipio' type = 'select' value = {formCliente.municipio} error = {errorsCliente.municipio} onChange = {(e: any) => onChangeFormCliente('municipio', e.value)}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm onBlur = {handleBlurFormCliente} required name = 'direccion' placeholder = 'Dirección' label = 'Dirección' type = 'text' value = {formCliente.direccion} error = {errorsCliente.direccion} onChange = {handleChangeFormCliente}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputChips maxChips={5} chips={formCliente.chipsEmail} setChips={(chipsEmail: Array<string>) => onChangeFormCliente('chipsEmail', chipsEmail)} maxLength = {50} onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/>
                        {/* <InputForm onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/> */}
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm required options = {actividadesEconomicas.map((act) => ({...act, codigo_valor: `${act.codigo}-${act.valor}`}))} keyNameText = 'codigo_valor' keyNameValue = 'codigo' name = 'actividad' placeholder = 'Actividad económica' label = 'Actividad económica' type = 'select' value = {formCliente.actividad} error = {errorsCliente.actividad} onChange = {(e: any) => onChangeFormCliente('actividad', e.value)}/>
                        <InputForm onBlur = {handleBlurFormCliente} required name = 'telefono' placeholder = 'Teléfono celular' label = 'Teléfono celular' type = 'phone' value = {formCliente.telefono} error = {errorsCliente.telefono} onChange = {(phone: any) => onChangeFormCliente('telefono', phone)}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <div className='label-input'>
                        <InputForm onBlur = {handleBlurFormCliente} required = {formCliente.tipoDocumento === '36'} name = 'nrc' placeholder = 'NRC' label = 'NRC' type = 'text' value = {formCliente.nrc} error = {errorsCliente.nrc} onChange = {handleChangeFormCliente}/>
                        </div><div className='label-input'></div>
                    </div>
                    {/* <h3 className="card-title">Venta a cuenta de terceros</h3>
                    <div className="separador"/>
                    <div className="otros-documentos-form">
                        <InputForm onBlur = {handleBlurFormCliente} name = 'nitTercero' placeholder = 'NIT' label = 'NIT' type = 'text' value = {formCliente.nitTercero} error = {errorsCliente.nitTercero} onChange = {handleChangeFormCliente}/>
                        <InputForm onBlur = {handleBlurFormCliente} name = 'nombreTercero' placeholder = 'Nombre' label = 'Nombre' type = 'text' value = {formCliente.nombreTercero} error = {errorsCliente.nombreTercero} onChange = {handleChangeFormCliente}/>
                    </div> */}
                </BasicCardDocumentos>
                </div>
                <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
                <BasicCardDocumentos title="Sucursal y serie">
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} required options = {formCliente?.datosSucursal} keyNameText = 'nombre' keyNameValue = 'idsucursal' name = 'sucursal' placeholder = 'Sucursal' label = 'Sucursal' type = 'select' value = {formCliente.sucursal} error = {errorsCliente.sucursal} onChange = {(e: any) => onChangeFormCliente('sucursal', e.value)}/>
                        <InputForm disabled={!formCliente.loadedSucursal} required options = {formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente?.sucursal)?.Documento?.map((doc: any) => ({...doc, serie_numero: `${doc.serie}-${doc.numeroactual}`}))} keyNameText = 'serie_numero' keyNameValue = 'idsucursaldocumento' name = 'serie' placeholder = 'Serie' label = 'Serie' type = 'select' value = {formCliente.serie} error = {errorsCliente.serie} onChange = {(e: any) => onChangeFormCliente('serie', e.value)}/>
                    </div>
                    <hr className="separador"/>
                    <div style={{display: 'flex', gap: '30px'}}>
                        <h3 className="card-title">
                            Productos
                        </h3>
                    <InputForm required name = 'asociarDocumentos' label = 'Asociar documentos' type = 'checkbox' value = {asociarDocumentos} onChange = {button_asociarDocumentos}/>
                    </div>
                    <hr className="separador"/>
                    {!asociarDocumentos &&
                    <>
                        <div className="cf-row-inputs">
                        {/* <InputForm required name = 'descripcion' label = 'Exento' type = 'checkbox' value = {formProducto.exento} onChange = {(e: any) => onChangeFormProducto('exento', !formProducto.exento)}/> */}
                        <InputForm required name = 'descripcion' label = 'Incluye IVA' type = 'checkbox' value = {formProducto.conIva} onChange = {(e: any) => onChangeFormProducto('conIva', !formProducto.conIva)}/>
                        </div>
                        {!formProducto.exento &&
                            <p style={{color: '#019FC5'}}>Nota: Este {formProducto.servicio ? 'servicio' : 'producto'} lleva un 13% extra por concepto de IVA. ( {formProducto.servicio ? 'Servicio' : 'Producto'} gravado)</p>
                        }
                        {
                            (!customDescripcion && productosCatalogo.length > 0)
                            ? 
                                <InputForm 
                                    enableCreate={true} required 
                                    label = 'Descripción' type = 'select' 
                                    options = {productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.servicio, prod))} 
                                    keyNameText = 'descripcion' keyNameValue = 'clave' 
                                    onChange = {handleSelectCatalogoProducto}  
                                    value = {formProducto.clave} error = {errorsProducto.descripcion}
                                    componentSideLabel = {
                                        <CheckBoxFlag
                                          label="Activar texto con formato" 
                                          value={customDescripcion} 
                                          onChange={() => {
                                            setCustomDescripcion(true);
                                            setCheckTextoEnrequecido(true);
                                          }}
                                        />
                                    }
                                />
                            : (
                                <div className="w-layout-hflex h-inputs">
                                    <InputSwitchDescripcion defaultEnrequecido={checkTextoEnrequecido} className='m text-field w-input' maxLength = {1000} onBlur = {handleBlurFormProducto} required name = 'descripcion' placeholder = 'Descripción' label = 'Descripción' type = 'text' value = {formProducto.descripcion} error = {errorsProducto.descripcion} onChange = {handleChangeFormProducto}/>    
                                </div>
                            )
                        }
                        <div style={{flexDirection: "row"}} >
                            <div className={`ef-form-producto-div4`}>
                            <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'cantidad' placeholder = '0' label = 'Cantidad' type = 'text' value = {formProducto.cantidad} error = {errorsProducto.cantidad} onChange = {handleChangeFormProducto}/>
                            <InputForm type = 'select' options = {unidadesMedida} keyNameText = 'valor' keyNameValue = 'codigo' onChange = {(e: any) => onChangeFormProducto('unidadMedida', e.value)} label = 'Unidad de medida' value = {formProducto.unidadMedida}/>
                            <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'precio' placeholder = '$0.00' label = 'Precio' type = 'text' value = {formProducto.precio} error = {errorsProducto.precio} onChange = {handleChangeFormProducto}/>
                            <InputForm options = {[{nombre: 'Porcentaje'}, {nombre: 'Monto'}]} keyNameText = 'nombre' keyNameValue = 'nombre' name = 'tipoDescuento' placeholder = 'Tipo de descuento' label = 'Tipo de desc.' type = 'select' value = {formProducto.tipoDescuento} error = {null} onChange = {(e: any) => onChangeFormProducto('tipoDescuento', e.value)}/>
                            <InputForm maxLength = {formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15} onBlur = {handleBlurFormProducto} name = 'descuento' placeholder = '$0.00' label = 'Descuento' type = 'text' value = {formProducto.descuento} error = {errorsProducto.descuento} onChange = {handleChangeFormProducto}/>
                            </div>
                        </div>
                            <div className="cf-calculos-producto">
                                <table>
                                    <tbody>
                                        <tr className="cf-subtotal">
                                            <td>Valor bruto</td>
                                            <td>{calculosProducto?.neto}</td>
                                        </tr>
                                        <tr className="cf-descuento">
                                            <td>Descuento</td>
                                            <td>{calculosProducto?.descuento}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Subtotal</td>
                                            <td>{calculosProducto?.subtotal}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Impuesto al Valor Agregado 13%
                                            </td>
                                            <td>{calculosProducto?.iva}</td>
                                        </tr>
                                        <tr className="cf-subtotal opacity-full-gray">
                                            <td>
                                                <Tooltip content='Cálculo de impuestos aplica en el resumen'>
                                                    <button className='table-action no-background'>
                                                        <img src={HelpIcon} className='help-icon-button' />
                                                    </button>
                                                </Tooltip>
                                                Otros impuestos
                                            </td>
                                            <td>{calculosProducto?.otrosImpuestos}</td>
                                        </tr>
                                        <tr className="cf-total">
                                            <td>Total</td>
                                            <td>{calculosProducto?.total}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="w-layout-hflex button-actions">
                                    <button className="button transparent" onClick={() => {button_onClickLimpiarFormProducto(); setCustomDescripcion(false)}}>Limpiar</button>
                                    <button className="button" onClick={() => {button_onClickAgregarProducto(); setCustomDescripcion(false)}}>Agregar</button>
                                </div>
                            </div>
                        </>
                    }
                    {asociarDocumentos &&
                        <>
                        {documentosAsociados?.length > 0 ?
                                        <div className="tab-plane">
                                        <table className="table-main-responsive responsive-table-main td-left table-pointer">
                                            <thead>
                                                <tr>
                                                    <td>Correlativo</td>
                                                    <td>Tipo de documento</td>
                                                    <td>Fecha y hora</td>
                                                    <td>Acciones</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableDocumentosAsociados.map((documento: any, index) => {
                                                    let fechaSplit = documento?.fechaEmision.split(' ')[0].split('-')
                                                    let fecha = `${fechaSplit[2]}/${fechaSplit[1]}/${fechaSplit[0]}`
                                                    let fechaYHora = `${fecha} ${documento?.fechaEmision.split(' ')[1]}`   
                                                    
                                                    return(
                                                    <tr key={index}>
                                                        <td data-label="Correlativo">{documento?.fisico ? documento?.codigoGeneracion : documento?.numeroControl}</td>
                                                        <td data-label="Tipo de documento">{tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documento?.tipoDocumento)?.nombre}</td>
                                                        <td data-label="Fecha y hora">{documento?.fisico ? fecha : fechaYHora}</td>
                                                        <td data-label="Acciones">
                                                            <button  onClick={() => actionButton_desasociar(documento?.numeroControl)} style={{borderRadius: '4px', background: 'red', color: '#fff'}}  >
                                                                Quitar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )})}
                                            </tbody>
                                        </table>
                                        <Pagination data = {documentosAsociados} state = {(items: Array<any>) => setTableDocumentosAsociados(items)} items = {5}/>
                                        <div style={{display: 'flex', width: '100%',justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '30px', margin: '5% 10px'}}>
                                            <button onClick={() => buttonActiveModalBusquedaDocumentos(true)} style={{display: 'flex', width:"auto", borderRadius: '40px'}} className="button">Buscar documentos</button>
                                            <button className='m button' style={{width:"auto",borderRadius: "50px"}} onClick={() => {modal_OpenDocumentoFisico(true)}} >Agregar documento físico</button>
                                        </div>
                                        </div>
                                        :
                                        <div style={{display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '30px'}}>
                                            Sin documentos asociados.
                                            <button onClick={() => buttonActiveModalBusquedaDocumentos(true)} style={{display: 'flex', width:"250px", minWidth:"100px", borderRadius: '40px'}} className="button">Buscar documentos</button>
                                            <button className='m button' style={{width:"250px", minWidth:"100px", borderRadius: "50px"}} onClick={() => {modal_OpenDocumentoFisico(true)}} >Agregar documento físico</button>
                                        </div>
                        }
                        
                        </>
                    }  
                </BasicCardDocumentos>                
                </div>
                </div>
            </div>
            
            {existenFisicos() && <div className="otros-documentos-container">
                <div className="card">
                    <button className='m button' style={{width:"auto", borderRadius: "50px"}} onClick={() => {modal_OpenAgregarProdFisico(true)}}>Agregar producto</button>
                </div>
            </div>}
            
        <div className="w-100">
            <div className="w-layout-layout bill-section wf-layout-layout">
            <BasicCardDocumentos title="Detalle de productos" style={{ maxWidth: "100%", boxShadow: "none" }}>
                <div className="tab-plane">
                    <div className="table-facturacion-resp">
                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                            <thead>
                                <tr>
                                    <td>Cantidad</td>
                                    <td>Unidad de medida</td>
                                    <td>Tipo</td>
                                    <td>Descripción</td>
                                    <td>Precio unitario</td>
                                    <td>Otros impuestos</td>
                                    <td>Descuento</td>
                                    <td>Ventas gravadas</td>
                                    <td>Ventas exentas</td>
                                    <td>Acciones</td>
                                </tr>
                            </thead>
                            <tbody>
                                {tableProductos?.map((producto, index) => {
                                    let precioUnitario = 0
                                    let descuento = 0
                                    let gravadas = 0
                                    let exentas = 0
                                    let detalleTributos = ''

                                    precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                                    descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (parseFloat(producto.descuento)/100*precioUnitario) * parseFloat(producto.cantidad) : parseFloat(producto.descuento) 
                                    gravadas = (precioUnitario * parseFloat(producto.cantidad)) - descuento
                                    exentas = (precioUnitario * parseFloat(producto.cantidad)) - descuento   
                                    detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '04', producto, gravadas);

                                    return(
                                    <tr key={index}>
                                        <td data-label="Cantidad">{producto.cantidad}</td>
                                        <td data-label="Unidad de medida">{unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                        <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                        <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                        <td data-label="Precio unitario">{precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                        <td data-label="Descuento">{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        <td data-label="Ventas gravadas">{!producto.exento ? (isNaN(gravadas) ? '$0.00' : gravadas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                        <td data-label="Ventas exentas">{producto.exento ? (isNaN(exentas) ? '$0.00' : exentas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                        <td data-label="Acciones">
                                            <button onClick={() => actionButton_editar(producto, index)}><img src={EditIcon} alt="edit"/></button>
                                            <button onClick={() => actionButton_eliminarProducto(index)}><img src={DeleteIcon} alt="delete"/></button>
                                        </td>
                                    </tr>
                                )})}
                            </tbody>
                    </table>
                    </div>
                        <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                        <div className="cf-calculos-producto">
                            <table>
                                <tbody>
                                    <tr className="cf-subtotal">
                                        <td>Suma de operaciones</td>
                                        <td>{sumaOperaciones.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Impuesto al Valor Agregado 13%</td>
                                        <td>{iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Otros impuestos</td>
                                        <td>{otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Subtotal</td>
                                        <td>{(subtotal).toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>IVA percibido 1%</td>
                                        <td>{ivaPercibido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>IVA retenido 1%</td>
                                        <td>{ivaRetenido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-descuento">
                                        <td>Retencion renta 10%</td>
                                        <td>{retencionRenta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-total">
                                        <td>Total</td>
                                        <td>{total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
            </BasicCardDocumentos>
            </div>
            <div className="w-layout-layout bill-section wf-layout-layout">
                <ObservacionesDocumentoBase
                    formObservaciones={formObservaciones}
                    onChange={(field, value) => dispatch({ type: NOTA_REMISION_TYPES.NR_FORMOBSERVACIONES_HANDLE_CHANGE, payload: { [field]: value } })}
                />
                <DocumentosReceptor />
            </div>
        </div>
        </>
    )
}